// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from logo.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function LogoIcon(props) {
  return (
    <svg
      width="24"
      height="28"
      viewBox="0 0 24 28"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#fff" d="M3.886 3.945H21.03v16.047H3.886z" />
      <path
        d="M0 2.005C0 .898.897 0 2.005 0h19.99C23.102 0 24 .897 24 2.005v19.99A2.005 2.005 0 0 1 21.995 24H2.005A2.005 2.005 0 0 1 0 21.995V2.005ZM9 24l3 4 3-4H9ZM7.008 4H4v16h3.008v-4.997C7.008 12.005 8.168 12.01 9 12c1 .007 2.019.06 2.019 2.003V20h3.008v-6.891C14.027 10 12 9.003 10 9.003c-1.99 0-2 0-2.992 1.999V4ZM19 19.987c1.105 0 2-.893 2-1.994A1.997 1.997 0 0 0 19 16c-1.105 0-2 .892-2 1.993s.895 1.994 2 1.994Z"
        fill="currentColor"
        fill-rule="evenodd"
      />
    </svg>
  );
}
